import { useParams } from "react-router-dom";
import React from "react";
import PageHeader from "@/custolink-views/asset_frontend/ui/layout/PageHeader";
import PageContent from "@/custolink-views/asset_frontend/ui/layout/PageContent";
import { Tag } from "@/components/ui";
import { useQuery } from "@tanstack/react-query";
import { FrontendDownloadBundleApi } from "@/custolink-transpiled_by_server/bc.asset_files.api_methods";
import { FrontendDownloadBundleApi as FrontendDownloadBundleApiGeneric }
  from "@/custolink-transpiled_by_server/bc.asset_files.api_generic";
import Loading from "@/components/shared/Loading";
import GetPath from "@/custolink-logic/api/GetPath";
import { useAssetFrontendDesign } from "@/custolink-views/asset_frontend/redesigns/assetFrontendDesign";
import AssetFilesDownloadLinkDesign from "@/custolink-views/etc/AssetFilesDownloadLinkDesign";

export default function AssetFilesDownloadLink() {
  const { token } = useParams();
  const newDesign = useAssetFrontendDesign();
  const q = useQuery({
    queryFn: () =>
      FrontendDownloadBundleApi.getInfoForToken(token ?? ""),
    queryKey: ["asset_files_download_link", token],
    enabled: !newDesign,
  });

  if (newDesign) {
    return <AssetFilesDownloadLinkDesign />;
  }

  return (
    <>
      <PageHeader>
        <div className="flex items-center justify-between">
          <h3 className={"text-white"}>Asset Files Download Link</h3>
          <div></div>
        </div>
      </PageHeader>

      <PageContent>
        <Loading loading={q.isPending} />

        {
          q.data != null && q.data?.info == null && <>
            Nothing found..
          </>
        }

        {q.data != null && q.data?.info != null && (
          <>
            <div className="mr-2 rtl:ml-2">
              {q.data.info?.expired === true && (
                <Tag className="text-red-600 bg-red-100 dark:text-red-100 dark:bg-red-500/20 border-0">
                  Link is expired
                </Tag>
              )}
              {q.data.info?.expired === false && (
                <Tag className="bg-emerald-100 text-emerald-600 dark:bg-emerald-500/20 dark:text-emerald-100 border-0 rounded">
                  Link expires: {q.data?.info?.expiresAt}
                </Tag>
              )}
            </div>

            <div className="prose max-w-full">
              <h5>Title</h5>
              <p>{q.data.info?.name}</p>
              <h5>Description</h5>
              <p>{q.data.info?.description}</p>

              <a
                rel="noreferrer"
                href={
                  FrontendDownloadBundleApiGeneric.download(
                    GetPath,
                    token ?? "",
                  )
                }
                target={"_blank"}>
                Download
              </a>
            </div>
          </>
        )}
      </PageContent>
    </>
  );
}
